// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCQl6M080EtV07kmaETEE7DuWglYqhfk6U',
    authDomain: 'facturas-2.firebaseapp.com',
    projectId: 'facturas-2',
    storageBucket: 'facturas-2.appspot.com',
    messagingSenderId: '265219304584',
    appId: '1:265219304584:web:b92ef921a7371d467a833d'
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
